var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipt bill edit - Iconly Pro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.67034 15.4427L6.07661 14.7918C5.72999 14.6503 5.33959 14.6619 5.00246 14.8232L4.43765 15.0932C3.84292 15.3785 3.15552 14.9444 3.15625 14.2862L3.16282 5.16891C3.16282 3.36721 4.16619 2.25 5.96497 2.25H11.3948C13.1987 2.25 14.1795 3.36721 14.1795 5.16891V8.31405",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2104 6.67969H6.56836M8.99618 9.5088H6.56836",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3888 15.635L10.7633 15.7401C10.3051 15.8168 9.90084 15.4351 9.95042 14.9732L10.0205 14.3273C10.0541 14.0165 10.1847 13.7231 10.3934 13.4897L12.7789 10.8546C13.1006 10.5065 13.6443 10.4853 13.9924 10.8079L14.5674 11.3406C14.9155 11.6624 14.9366 12.206 14.6149 12.5541L12.2593 15.1556C12.0316 15.4096 11.7251 15.5789 11.3888 15.635Z",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptBill);
export default __webpack_public_path__ + "static/media/receipt_bill.b0ced11f23b331ced46a17243780f387.svg";
export { ForwardRef as ReactComponent };